import React, { useMemo } from 'react';

import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { ModalEntryPoint } from '../shared/modal-entry-point';

import { FREE_DIALOG_CONFIG, STANDARD_DIALOG_CONFIG } from './dialog-config';
import entryPoint from './entrypoint';

export function AutomationLimitsModal() {
	const { edition } = useEditionAwareness();

	const DIALOG_CONFIG = useMemo(() => {
		if (edition === 'free') {
			return FREE_DIALOG_CONFIG;
		} else if (edition === 'standard') {
			return STANDARD_DIALOG_CONFIG;
		}
		throw new Error(`Unsupported edition: ${edition}`);
	}, [edition]);

	return <ModalEntryPoint entryPoint={entryPoint} dialogConfig={DIALOG_CONFIG} />;
}
